import { useSelector } from 'react-redux';

import { TimerButton } from 'libs/ui';
import { RackPrint } from './rack-print/rack-print';
import { Content } from './rack-actions.styled';

export const RackActions = (props) => {
  const { id, sendControlMsg } = props;
  const with_allow_payment_mean = useSelector((store) => store.equipment[id]?.with_allow_payment_mean);
  const rightControl = window.haveRight('mnemo.rack_control');
  const rightAllowPM = window.haveRight('mnemo.allow_payment_mean');

  return (
    <Content>
      <RackPrint id={id} sendControlMsg={sendControlMsg} />

      {with_allow_payment_mean && rightAllowPM && (
        <TimerButton title="Разрешить СО" icon="ticket.png" action={() => sendControlMsg('allow_payment_mean')} />
      )}

      {rightControl && <TimerButton title="Разблокировать оборудование" icon="unlock.png" action={() => sendControlMsg('unblock')} timeout={10000} />}

      {rightControl && <TimerButton title="Обновить ГРЗ" icon="rebut.png" action={() => sendControlMsg('run_recognition')} timeout={500} />}
    </Content>
  );
};
